//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/list'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/progress_bar'
import 'devextreme/ui/popover'
import 'devextreme/ui/popup'
import 'devextreme/ui/select_box'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'

import { Enums } from '../../../models/common/enums'

import { DATA_TYPE_SERVICE_NAME, DataTypeService, DATA_TYPE_FORMAT_SERVICE_NAME, DataTypeFormatService } from '../../../services/data-type'
import { GRID_SERVICE_NAME, GridService } from '../../../services/grid'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $ROOT_SCOPE_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { ImportController } from './import.controller'

import { ImportService, IMPORT_SERVICE_NAME, ImportErrorsSummaryService, IMPORT_ERRORS_SUMMARY_SERVICE_NAME, ImportGridService, IMPORT_GRID_SERVICE_NAME, IMPORT_DATA_SERVICE_NAME, ImportDataService } from './services'

//#region Assets Imports

import './import.scss'
import * as TEMPLATE from './import.tpl.html'

//#endregion

export interface ImportOptions {
    dictionaryMethodName: string
    requestMethodType: string
    popupName: string
    referenceType: Enums.ReferenceType
    moduleName: Enums.SimaxModuleName
    columnsReorderingDisabled: boolean
}

export class ImportDirective implements ng.IDirective {

    restrict = 'E'
    scope = {
        options: '=',
        gridId: '=?'
    }

    template = TEMPLATE

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        DATA_TYPE_SERVICE_NAME,
        DATA_TYPE_FORMAT_SERVICE_NAME,
        IMPORT_SERVICE_NAME,
        IMPORT_ERRORS_SUMMARY_SERVICE_NAME,
        IMPORT_DATA_SERVICE_NAME,
        IMPORT_GRID_SERVICE_NAME,
        (
            $scope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            userSessionService: UserSessionService,
            dataTypeService: DataTypeService,
            dataTypeFormatService: DataTypeFormatService,
            importService: ImportService,
            importErrorsSummaryService: ImportErrorsSummaryService,
            importDataService: ImportDataService,
            importGridService: ImportGridService
        ) => {
            return new ImportController(
                $scope,
                $q,
                $timeout,
                userSessionService,
                dataTypeService,
                dataTypeFormatService,
                importService,
                importErrorsSummaryService,
                importDataService,
                importGridService
            )
        }]
}